import { render, staticRenderFns } from "./ry_push.vue?vue&type=template&id=796d458f&scoped=true"
import script from "./ry_push.vue?vue&type=script&lang=ts"
export * from "./ry_push.vue?vue&type=script&lang=ts"
import style0 from "./ry_push.vue?vue&type=style&index=0&id=796d458f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796d458f",
  null
  
)

export default component.exports